// Modules
import React from 'react'
import { Redirect } from 'react-router-dom'

export interface RedirectBuilderProps {
    redirectPath: string
}

export const RedirectBuilder: React.VFC<RedirectBuilderProps> = ({ redirectPath }) => <Redirect to={redirectPath} />
